import { cn } from '@/utils/cn';
import PlatformKeyVisual from './PlatformKeyVisual';
import type { HomePlatformTheme } from './homeThemes';

interface PlatformQuickCardProps {
  theme: HomePlatformTheme;
  onClick: () => void;
}

export default function PlatformQuickCard({ theme, onClick }: PlatformQuickCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'h-[78px] w-[94px] shrink-0 overflow-hidden rounded-[14px] bg-gradient-to-br p-[1px] shadow-[0_10px_22px_rgba(15,23,42,0.24)] transition-transform active:scale-[0.98]',
        theme.frame
      )}
    >
      <div className={cn('home-premium-surface relative h-full overflow-hidden rounded-[13px] bg-gradient-to-br px-1.5 py-1.5 text-center text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.26),inset_0_-12px_18px_rgba(0,0,0,0.26)]', theme.panel)}>
        <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(255,255,255,0.22),transparent_42%),radial-gradient(circle_at_80%_18%,rgba(255,255,255,0.28),transparent_20%),radial-gradient(circle_at_18%_86%,rgba(251,191,36,0.18),transparent_26%)]" />
        <div className="absolute inset-x-0 top-1 flex justify-center">
          <PlatformKeyVisual platform={theme.key} className="h-[56px] w-[56px] rounded-xl shadow-[0_8px_18px_rgba(0,0,0,0.3)]" />
        </div>
        <div className="absolute inset-x-0 bottom-0 h-7 bg-gradient-to-t from-black/55 via-black/24 to-transparent" />
        <div className="absolute bottom-1 left-1/2 inline-flex max-w-[88px] -translate-x-1/2 whitespace-nowrap rounded-full border border-white/18 bg-black/28 px-2 py-0.5 text-[9px] font-bold leading-none shadow-[inset_0_0_8px_rgba(255,255,255,0.18)] backdrop-blur-sm">
          {theme.quickLabel}
        </div>
      </div>
    </button>
  );
}
